var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({minHeight: '500px', marginTop: _vm.landscape_mode ? '120px' : ''})},[_c('phrases-list',{class:false ? 'pt-5' : '',attrs:{"data":_vm.filtered_phrases,"filter":'all'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }